import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OtherService } from 'src/app/services/other.service';
import { AccountService } from 'src/app/services/account.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NationalCodeService } from 'ngx-persian';
import { MapService } from 'src/app/services/map.service';
import { Meta, Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import html2canvas from 'html2canvas';
import { Router } from '@angular/router';

@Component({
  selector: 'app-work-profile',
  templateUrl: './work-profile.component.html',
  styleUrls: ['./work-profile.component.css'],
})

export class WorkProfileComponent implements OnInit {
  @ViewChild('paymentDialogTemplate') paymentDialogTemplate: TemplateRef<any>;
  @ViewChild('tankerInvoiceDialogTemplate') tankerInvoiceDialogTemplate: TemplateRef<any>;

  activeAccordion: 1 | 2 = 1;
  Info: any;
  lst_States: any = [];
  list_City: any = [];
  lst_FloatingType: any = [];
  forceAddress: number = (<any>window).forceAddress;
  addressPlaceHolder: string = '';
  protected forcePayment: boolean = (<any>window).forcePayment;
  openMap: boolean = false;

  mdl_User: FormGroup = this.formBuilder.group({
    iPreregistration: new FormControl(''),
    strSession: new FormControl(''),
    strName: new FormControl('', Validators.required),
    strFamily: new FormControl('', Validators.required),
    strID: new FormControl('', Validators.required),
    strState: new FormControl('', Validators.required),
    strCity: new FormControl('', Validators.required),
    strMobile: new FormControl('', Validators.required),
    strAddress: new FormControl(''),
    fLat: new FormControl(0),
    fLon: new FormControl(0),
    tiFloatingType: new FormControl('', Validators.required),
    iPower: new FormControl('', Validators.required),
    strComment: new FormControl(''),
    strLicenseNo: new FormControl(''),
    strRegisterDateTime: new FormControl({ value: '', disabled: true }),
    strAnnouncementTime: new FormControl({ value: '', disabled: true }),
    strMobile1: new FormControl({ value: '', disabled: true }),
    strFullName: new FormControl({ value: '', disabled: true }),
    strInstallDate: new FormControl({ value: '', disabled: true }),
    strInstallerComment: new FormControl({ value: '', disabled: true }),
    strInstallationStatus: new FormControl(''),
    tiInstallationStatus: new FormControl(''),
    bHas12DC: new FormControl(false),
    bInstallment: new FormControl({ value: false, disabled: true }),
    strPaymentComment: new FormControl({ value: '', disabled: true }),
    iTrackingCode: new FormControl({ value: '', disabled: true }),
    strCooperativeName: new FormControl(''),
    strMotorType: new FormControl(''),
    strMotorBrand: new FormControl(''),
  });

  mdl_Map: FormGroup = this.formBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  });

  mdl_Payment: FormGroup = this.formBuilder.group({

    iResult: new FormControl(''),

    strURL: new FormControl(''),

  });

  unSubscribeAll$ = new Subject<void>();

  constructor(

    private otherService: OtherService,

    private formBuilder: FormBuilder,

    private accountService: AccountService,

    private _NationalCode: NationalCodeService,

    private _MapService: MapService,

    private meta: Meta,

    private ngbModal: NgbModal,

    private title: Title,

    private router: Router

  ) {

    this.addressPlaceHolder = this.forceAddress ? '* اسکله محل نصب (الزامی)' : 'اسکله محل نصب (اختیاری)';

  }

  ngOnInit(): void {

    this.title.setTitle('پروفایل کاربری | شاپد – سامانه شناسایی، احراز هویت و پایش دریایی');


    if (this.forceAddress) {

      const address = this.mdl_User.get('strAddress');
      address?.addValidators(Validators.required);
      address?.updateValueAndValidity();

      const fLat = this.mdl_User.get('fLat');
      fLat?.addValidators(Validators.required);
      fLat?.updateValueAndValidity();

      const fLon = this.mdl_User.get('fLon');
      fLon?.addValidators(Validators.required);
      fLon?.updateValueAndValidity();

    }

    this.Info = this.otherService.getLocalStorage();

    var model = {

      iPreregistration: this.Info.Id,

      strSession: this.Info.session,

    };

    this.accountService.userInfo(model).subscribe((userData) => {

      let res = JSON.parse(userData.toString());

      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      Object.keys(res[0]).forEach((key) => {

        this.mdl_User.get(key)?.setValue(res[0][key]);

      });

      this.getCity(res[0].strState);

      const status = this.mdl_User.get('tiInstallationStatus').value || 0;

      this.activeAccordion = status < 3 ? 2 : 1;

      this.mdl_User.patchValue({

        iPreregistration: this.Info.Id,

        strSession: this.Info.session,



      });

      this.mdl_Payment.patchValue({

        iResult: status

      });

      this.mdl_User.get('strID')?.disable();

      this.mdl_User.get('strMobile')?.disable();

      if (status > 2) {

        this.mdl_User.disable();

      }

      if (status == 0 && this.forcePayment) {

        this.showAlert();

      }

    });

    this.accountService.GetState().subscribe((response) => {

      let res = JSON.parse(response.toString());

      this.lst_States = res;

    });

    this.accountService.floatingType().subscribe((response) => {

      let res = JSON.parse(response.toString());

      this.lst_FloatingType = res;

    });

  }

  ngOnDestroy(): void {

    this.unSubscribeAll();

  }

  isOpen(accordion: 1 | 2) {

    return this.activeAccordion === accordion;

  }

  getCity(id) {

    this.accountService.GetCity(id).subscribe((response: any) => {

      let res = JSON.parse(response.toString());

      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      // this.signUpModel.get('strCity')?.setValue('');

      this.list_City = res;

    });

  }

  show_Map() {

    let model = this.mdl_User.value;

    if (model.strAddress == '') {

      this._MapService.getCurrentLocation().then(coords => {

        this.mdl_Map.patchValue({

          strAddress: model.strAddress,

          fLon: coords.longitude || 0,

          fLat: coords.latitude || 0,

          strSource: 'strAddress',

        });

        this.openMap = true;

      }).catch(error => {

        this.mdl_Map.patchValue({

          strAddress: model.strAddress,

          fLon: model.fLon || 0,

          fLat: model.fLat || 0,

          strSource: 'strAddress',

        });

        this.openMap = true;

        console.error('Error getting location:', error);

      });


    }

    else {

      this.mdl_Map.patchValue({

        strAddress: this.baseAddress(),

        fLon: model.fLon || 0,

        fLat: model.fLat || 0,

        strSource: 'strAddress',

      });

      this.openMap = true;

    }

  }

  baseAddress(): string {

    const { strCity, strAddress } = this.mdl_User.value;

    const cityObj = this.list_City.find(c => c.strCity === strCity);

    if (!cityObj) return strAddress?.trim() ?? '';

    const cityName = cityObj.strCityName?.trim();

    if (!cityName) return strAddress?.trim() ?? '';

    const normalizedAddress = strAddress?.trim() ?? '';

    if (normalizedAddress.startsWith(cityName)) {

      return normalizedAddress;

    }

    return `${cityName}، ${normalizedAddress}`;

  }

  submitMap(event: any) {

    this.openMap = false;

    if (event.strText != '') {

      this.mdl_User.patchValue({

        strAddress: event.strText,

        fLon: event.longitude,

        fLat: event.latitude,

      });

    }

    else {

      this.mdl_User.patchValue({

        strAddress: '',

        fLon: 0,

        fLat: 0,

      });

    }

  }

  preInvoiceDetail;

  showAlert() {
    var model = {
      iPreregistration: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.preInvoiceDetail(model).subscribe((response: string) => {
      const res = JSON.parse(response);
      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }
      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      this.preInvoiceDetail = JSON.parse(res.strDetail);
    });

    const dialogRef = this.ngbModal.open(this.paymentDialogTemplate, { scrollable: true, container: 'app-work-profile', modalDialogClass: 'payment-dialog', centered: true, animation: false, backdrop: 'static', keyboard: false });
    dialogRef.dismissed.subscribe(() => {
      this.preInvoiceDetail = null;
    });
  }

  tankerInvoiceData;

  shilatInvoice() {
    var model = {
      iPreregistration: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.shilatInvoice(model).subscribe((response: string) => {
      let res = JSON.parse(response);
      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }
      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);
      this.tankerInvoiceData = JSON.parse(res.strDetail);
    });
    const dialogRef = this.ngbModal.open(this.tankerInvoiceDialogTemplate, { scrollable: true, container: 'app-work-profile', modalDialogClass: 'payment-dialog', centered: true, animation: false });
    dialogRef.dismissed.subscribe(() => {
      this.tankerInvoiceData = null;
    });
  }

  openUrl() {

    const paymentUrl = this.mdl_Payment.get('strURL')?.value;

    if (paymentUrl) {

      window.open(paymentUrl, '_self');

      return

    }

    else {

      var model = {
        iPreregistration: this.Info.Id,
        strSession: this.Info.session,
      };

      this.accountService.payInvoice(model).pipe(takeUntil(this.unSubscribeAll$)).subscribe((userData) => {
        let res = JSON.parse(userData.toString());
        if (res.iResult == 0) {
          return this.accountService.toastSwal('error', res.strError);
        }

        this.mdl_Payment.patchValue({
          strURL: res.strURL
        });

        window.open(res.strURL, '_self', '');

      });

    }

  }


  update_Info() {

    let model = this.mdl_User.getRawValue();;

    this.markAllAsTouched(this.mdl_User);

    if (this.mdl_User.invalid) {
      console.log(this.mdl_User.controls)

      return this.accountService.toastSwal('error', 'فیلدهای ضرروی را وارد کنید');

    }

    // if (model.fLat == 0 || model.fLon == 0) {

    //   return this.accountService.toastSwal('error', 'آدرس را از روی نقشه انتخاب کنید');

    // }

    else {

      Swal.fire({

        title: 'آیا از ویراش اطلاعات اطمینان دارید؟',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        reverseButtons: true,

        confirmButtonColor: '#10b981',

        confirmButtonText: 'تایید',

        cancelButtonText: 'لغو',

      }).then((result) => {

        if (result.isConfirmed) {

          this.accountService.update_UserInfo(this.otherService.stringNumberToNumber(model)).subscribe((data) => {

            let res = JSON.parse(data.toString());

            if (res?.ISSessionExpired === true) {
              this.otherService.logout();
              this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
              this.accountService.toastSwal(
                'error',
                'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
              );
            }

            if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

            this.accountService.toastSwal('success', 'اطلاعات با موفقیت ویرایش شد');


          });

        }

      });

    }

  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }

  dismiss(reason: string): void {

    this.ngbModal.dismissAll();

  }

  paymentProcess() {

    var model = {

      iPreregistration: this.Info.Id,

      strSession: this.Info.session,

    };

    this.accountService.payInvoice(model).subscribe((userData) => {

      let res = JSON.parse(userData.toString());

      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      this.mdl_Payment.patchValue({

        strURL: res.strURL

      });

      window.open(this.mdl_Payment.get('strURL')?.value, '_self', '');

    });

  }

  saveShot() {

    const element = document.getElementById('payment-receipt');

    if (!element) return;

    html2canvas(element, {

      scale: 2,

      useCORS: true,

      ignoreElements: (el) => {

        return el.classList.contains('receipt-title');

      }

    }).then(canvas => {

      const link = document.createElement('a');

      link.download = `receipt-${Date.now()}.png`;

      link.href = canvas.toDataURL('image/png');

      link.click();

    });

  }

  unSubscribeAll() {

    this.unSubscribeAll$.next();

    this.unSubscribeAll$.complete();
  }



}

